/**
 * Node move handler
 *
 * @param   {event}  event
 * @param   {object}  moveData
 * @return  {void}
 */
export default function (event, moveData) {
    return;
}
